<template>
  <div>
    <b-navbar sticky="true" type="light" variant="light">
		<div class="container">
			<b-navbar-brand to="/infection-feast">感染盛宴</b-navbar-brand>
			<b-navbar-nav class="ml-auto" small="true" >
				<!-- <b-nav-item to="#">概览</b-nav-item>
      			<b-nav-item to="#">如何使用</b-nav-item> -->
				<b-button rel="noopener" target="_blank" pill size="sm" variant="primary" @click="leaveFor" href="battlenet:://starcraft/map/5/90512" >前往战网游玩</b-button>
			</b-navbar-nav>
		</div>
    </b-navbar>

	<div class="card-container" >
      <div class="card-content" >
		  <div class="description-container" style="text-align: center;" >
              <div>
                <h1>感染盛宴</h1>
                <h3>我们最受欢迎的地图</h3>
                <p>2501年，埃罗尼亚星放弃独立，再次归属联邦，并开始着手收复沦陷的城市。
                尼科尔城，感染最为严重的城市，整个城市无人生还。
                泰伦联邦派遣了先头部队并成功建立了一个安全区，随后向地方部队请求援助。
                现在，是我们该出场了，修好灵能发射器，拯救这座城市。
                </p>
                <PartnerAuthor></PartnerAuthor>
              </div>
            </div>
			<div class="img-container" >
				<img src="@/assets/SC_Map/Infection_Feast/mine_area_be_attacked.png" >
			</div>
	  </div>
    </div>

	<div class="card-container" >
      <div class="card-content" >
        <b-row no-gutters>
          <b-col sm="6">
            
            <div class="img-container" >
              <img src="@/assets/SC_Map/Infection_Feast/base_be_attacked_1.png" >
            </div>
                
          </b-col>
          <b-col sm="6">
            
            <div class="description-container">
              <div>
                <h2>地图设计</h2>
				<h3>充满了绝望的都市</h3>
				<p>这里有大楼废墟、贫民窟、图书馆、医院？无所谓了，选择一个地方建立基地吧，指挥官。</p>
              </div>
            </div>
            
          </b-col>
        </b-row>
      </div>
    </div>
    
	<div class="card-container" >
      <div class="card-content" >
        <b-row no-gutters>

          <b-col sm="6">
            
            <div class="description-container">
              <div>
				<h2>感染机制</h2>
				<h3>经久不衰的游戏机制</h3>
				<p>同样的配方，还是那个味道，如此经典的游戏体验，这一次感染者使用的是斯托科夫单位的模型，视觉效果再提升。</p>
                </p>
              </div>
            </div>
            
          </b-col>

			<b-col sm="6">
				
				<div class="img-container" >
				<img src="@/assets/SC_Map/Infection_Feast/base_be_attacked_3.png" >
				</div>
					
			</b-col>
        </b-row>
      </div>
    </div>

  </div>
</template>

<style lang="stylus" scoped>
	@import '~@/components/OverviewCard.styl'
</style>

<script>
import PartnerAuthor from '@/components/PartnerAuthor'
export default {
    methods: {
        leaveFor() {
            this.$ga.event('sc-map', 'battlenet', 'infection-feast', 1)
            },
	},
  name: 'about',
    components: {
        PartnerAuthor
  }
}
</script>